import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box, styled, Typography } from '@mui/material';
import useShopifyProductSWR from '../../../../hooks/shopify/useShopifyProductSWR';
import { ProductImagesView } from '../../../product/ProductImages';
import { ProductDetails } from '../../../product/ProductDetails';
import { ProductPrices } from '../../../product/ProductPrices';
import { ProductAddTo } from '../../../product/ProductAddTo';
import { Breadcrumb } from '../../../product/Breadcrumb';
import { ProductTabDetails } from '../../../product/ProductTabDetails';
import { ProductStockStatus } from '../../../product/ProductStockStatus';
import { getShopifyID } from '../../../../utils/utils';
import { ProductShippingStatus } from '../../../product/ProductShippingStatus';
import { ProductPageLoadingLayout } from '../../../layouts/LoadingLayouts/ProductPageLoadingLayout';
import { ErrorTypography } from '../../../styled/ErrorTypography';

const StyledTitle = styled(Typography)(() => ({
    fontSize: '20px',
    color: '#232323',
    fontWeight: 600,
}));

const ProductContainer = styled(Box)(({ theme }) => ({
    display: 'grid',
    width: '100%',
    gridTemplateColumns: 'repeat(2, 1fr)',
    [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
    },
}));

const PageContainer = styled(Box)(() => ({
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
}));

export const ProductPage = () => {
    const { productHandle } = useParams();
    const { product, isLoading, isError } = useShopifyProductSWR(productHandle);
    const [selectedVariant, setSelectedVariant] = useState(null);

    if (isLoading) {
        return <ProductPageLoadingLayout />;
    }
    if (isError) {
        return <ErrorTypography errorCode={'PRODUCT_PAGE_LOADING_ERROR'} />;
    }

    if (!product) {
        return <ErrorTypography errorCode={'PRODUCT_PAGE_NO_PRODUCT'} />;
    }

    return (
        <PageContainer>
            <Breadcrumb
                collection={{
                    title: product.collections.nodes[0].title,
                    handle: product.collections.nodes[0].handle,
                }}
                product={{
                    title: product.title,
                    handle: product.handle,
                }}
            />
            <ProductContainer>
                <Box>
                    <ProductImagesView images={product.images.nodes} />
                </Box>
                <Box>
                    <StyledTitle variant="h1" gutterBottom>
                        {product.title}
                    </StyledTitle>
                    <ProductStockStatus
                        product={product}
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                    />
                    <ProductDetails
                        product={product}
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                    />
                    <ProductPrices
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                        productId={getShopifyID(product.id)}
                    />
                    <ProductAddTo
                        variant={
                            selectedVariant
                                ? selectedVariant
                                : product.variants.nodes[0]
                        }
                        metafields={product.metafields}
                    />
                    <ProductShippingStatus
                        availableQty={
                            product.variants.nodes[0].quantityAvailable
                        }
                    />
                </Box>
            </ProductContainer>
            <ProductTabDetails product={product} />
        </PageContainer>
    );
};
